<template>
	<div id="app">
		<app-stripes />
		<router-view v-slot="{ Component }">
			<keep-alive>
				<transition name="fade" mode="out-in">
					<component :is="Component" class="view" />
				</transition>
			</keep-alive>
		</router-view>
		<!-- <app-cookies/> -->
	</div>
</template>

<script>
import AppStripes from '@/components/AppHeaderStripes';
// Modal z ciastkami został usunięty - mBank uzywa swojego, ale na wypadek zostawiam
// import AppCookies from '@/components/AppCookies'

export default {
	components: {
		AppStripes,
		// AppCookies
	},
	methods: {
		resize() {
			this.$store.commit('setWindowWidth', window.innerWidth);
		},
	},
	beforeMount() {
		this.$store.commit('setWindowWidth', window.innerWidth);
		window.addEventListener('resize', this.resize);
	},
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
	transition: opacity ease 0.25s;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}
</style>
